const shortSearch = [
  "broccoli",
  "asparagus",
  "cauliflower",
  "corn",
  "green pepper",
  "mushrooms",
  "onion",
  "potato",
  "pumpkin",
  "red pepper",
  "tomato",
  "beetroot",
  "brussel sprouts",
  "peas",
  "zucchini",
  "sweet potato",
  "artichoke",
  "cabbage",
  "chili",
  "garlic",
  "basil",
  "green bean",
  "bean",
  "chickpea",
  "lentil",
  "apple",
  "avocado",
  "banana",
  "blackberry",
  "blueberry",
  "cherry",
  "coconut",
  "fig",
];

export default shortSearch;
